module.exports = __webpack_public_path__ + "img/inspiration_styles.4bb7b10.webp";